import React, { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OpenRequest from "./OpenRequest";
import AnsweredRequest from "./AnsweredRequest";
import { useUserStore } from "store/userStore";

const Request: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<"open" | "answered">("open");
  const primaryAirlineCode = useUserStore((state) => state.primaryAirlineCode);

  // Frozen on mount so clearing location.state below doesn't blank it out
  // before AnsweredRequest has consumed it (mirrors YourRequest.tsx).
  const [targetRequestId] = useState<number | string | null>(
    () => (location.state as any)?.targetRequestId ?? null,
  );

  // Sync tab from sidebar/notification navigation state
  useEffect(() => {
    if (location.state?.tab === "answered") {
      setActiveTab("answered");
    } else if (location.state?.tab === "open") {
      setActiveTab("open");
    }
  }, [location.state]);

  // Clear the one-shot navigation state once consumed, so revisiting this
  // page (e.g. via back button) doesn't re-trigger the deep link.
  useEffect(() => {
    if (targetRequestId) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [targetRequestId, location.pathname, navigate]);

  const TabContent = useMemo(
    () => ({
      open: <OpenRequest />,
      answered: <AnsweredRequest targetRequestId={targetRequestId} />,
    }),
    [targetRequestId]
  );

  return (
    <div className="-m-6">
      {/* Content */}
      <div className="px-6">
        {TabContent[activeTab]}
      </div>
    </div>
  );
};

export default Request;
